import { ArrowDownIconStyles } from './ArrowDownIconStyles'
import React from 'react'
// import { ArrowDownIconProps } from './types/ArrowDownIconProps'
import { ArrowLeftIcon } from '../ArrowLeftIcon/ArrowLeftIcon'

export const ArrowDownIcon = (): JSX.Element => {
  return <ArrowLeftIcon className={`ArrowRightIcon ${ArrowDownIconStyles}`} />
}
